import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_PREFIX, BASE_URL } from '@CONSTANTS/API.constant';
import userRepository from '@REPOSITORIES/local-repository/user-repository';
import { Brand } from '@INTERFACES/api/brands';

type BrandsApiResponse = {
    id: number;
    name: string;
    logo_svg: string | null;
    contract_types: number | null;
};

export const brandApi = createApi({
    reducerPath: 'brand-api',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL + API_PREFIX,
        prepareHeaders: (headers) => {
            const token = userRepository.getData();

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    endpoints: (builder) => ({
        getAll: builder.query<Brand[], void>({
            query: () => ({
                url: '/brands/',
            }),
            transformResponse: (raw: BrandsApiResponse[]): Brand[] => raw
                .map((brand) => ({
                    ...brand,
                    category: null, // Regular API doesn't provide category, so default to null
                }))
                .sort((a, b) => (a.name > b.name ? 1 : -1)),
            keepUnusedDataFor: 60 * 5, // 5 minutes
        }),
    }),
});

export const {
    useGetAllQuery: useGetAllBrands,
} = brandApi;
